var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.21 8.36V7.07c0-.17-.06-.32-.19-.45-.12-.13-.27-.19-.45-.19H9V3.86c0-.18-.06-.33-.19-.45-.13-.13-.28-.2-.45-.2H7.07c-.17 0-.32.07-.45.2-.13.12-.19.27-.19.45v2.57H3.86c-.18 0-.33.06-.45.19-.13.13-.2.28-.2.45v1.29c0 .17.07.32.2.45.12.13.27.19.45.19h2.57v2.57c0 .18.06.33.19.45.13.13.28.19.45.19h1.29c.17 0 .32-.06.45-.19.13-.12.19-.27.19-.45V9h2.57c.18 0 .33-.06.45-.19.13-.13.19-.28.19-.45zm3.22-.65c0 1.4-.35 2.69-1.04 3.88a7.67 7.67 0 0 1-2.8 2.8c-1.19.69-2.48 1.04-3.88 1.04s-2.69-.35-3.87-1.04a7.7 7.7 0 0 1-2.81-2.8C.34 10.4 0 9.11 0 7.71s.34-2.69 1.03-3.87 1.63-2.12 2.81-2.81S6.31 0 7.71 0s2.69.34 3.88 1.03a7.7 7.7 0 0 1 2.8 2.81c.69 1.18 1.04 2.47 1.04 3.87z"}));
}

Plus.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Plus;

Plus.default = Plus;
